import { CountrySearchPipe } from './../country-search.pipe';
import { QuotationBillPipe } from './../quotation-bill.pipe';
import { Component, OnInit } from '@angular/core';
declare var $: any;
import { ApiService } from '.././api.service';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Helper } from '../helper';
import { SearchSupplierPipe } from '../search-supplier.pipe';
import { SelectpinPipe } from '../selectpin.pipe';
import { DateComPipe } from '../date-com.pipe';
import { PlaceSearchPipe } from '../place-search.pipe';
import { SerchCodePipe } from '../serch-code.pipe';
import { CustomerIdPipe } from '../customer-id.pipe';
import { SamedatePipe } from '../samedate.pipe';
import { AreaFilterPipe } from '../area-filter.pipe';
import { DateComOrderPipe } from '../date-com-order.pipe';
import { OrderOnlyPipe } from '../order-only.pipe';
import { CategorySearchPipe } from '../category-search.pipe';
import { IdCustomerPipe } from '../id-customer.pipe';

declare var JsBarcode:any;
@Component({
  selector: 'app-payments-report',
  templateUrl: './payments-report.component.html',
  styleUrls: ['./payments-report.component.scss']
})
export class PaymentsReportComponent implements OnInit {

  arre: any;
  show = false;
  add: any = false;
  update: any = false;
  delete: any = false;
  name: any;
  email: any;
  password: any;
  adress: any;
  root: any = undefined;
  phone: any;
  control: any;
  idDI: any;
  rootA: any;
  controlA: any;
  nameU: any;
  emailU: any;
  passwordU: any;
  adressU: any;
  rootU: any;
  phoneU: any;
  controlU: any;
  idUp: any;
  searchName: any;
  rootSearch = 'Search By Branch';
  controlSearch = 'أبحث بالصلاحية';
  description: any;
  dimensions: any;
  fabric: any;
  category: any = undefined;
  qty: any;
  price: any;
  supplier: any = undefined;
  supplierA: any;
  serchCode: any;
  serchCodeStore: any;
  serchCode00: any;
  images: any = '';
  countImage: any;
  countImage0: any;
  arrImage: any;
  qwss = false;
  descriptionU: any;
  dimensionsU: any;
  fabricU: any;
   categoryU: any;
   qtyU: any;
   priceU: any;
   supplierU: any;
   rootU0: any;
   idUpI: any;
   allCa: any;
   payno: any;
   paynoArr: any;
   paynoU: any;
   codeOut: any;
   codeOutU: any;
   oldSupplier: any;
   placeSearch = 'Search By Branch';
   placeSearchStore = 'Search By Store';
   searchsupplier = 'Search By Company';
   searchsupplierBar = 'Search By Supplier';
   searchsupplierAdmin = 'Search By Company';
   searchsupplierAdmin1 = 'Search By Company';
   piNo: any = 0;
   go = false;
   dateorder: any;
   datereceipt: any;
   rootSa: any;
   excel: any;
   imageShowU = false;
   imageShowA = true;
   arrI: any;
   imgget =  false;
   categoryPrint: any;
   dimPrint: any;
   pricePrint: any;
   OrderDate00 = true;
   OrderDate01 = false;
   OrderDate000 = true;
   OrderDate010 = false;
   searchPINO: any = 'PI NO';
   selectpin: any = 'PI NO';
   selectpinAdmin: any = 'PI NO';
   selectpinAdmin1: any = 'PI NO';
   selectpinBar: any = 'PI NO';
   pi: any = [];
   piAdmin: any = [];
   piAdmin1: any = [];
   discoundPrint: any;
   valDis: any;
   pricePrint0: any;
   dis = false;
   dis0 = false;
   www: any;
   goImg: any = false;
   categorySearch: any = 'All';
   defect: any;
   defectU: any;
   notes: any;
   notesU: any;
   customer_id: any = 'undefined';
   arreCustomer: any;
   arreReportCustomer: any;
   arrePayment: any;
   arreParcode: any;
   arreStore: any;
   dateFrom: any = new Date().toJSON().slice(0,10);
   dateTo: any = new Date().toJSON().slice(0,10);
   dateFromAnoter: any = new Date().toJSON().slice(0,10);
   dateToAnoter: any = new Date().toJSON().slice(0,10);
   OrderDate000S: any = true;
   OrderDate000S0: any = false;
   OrderDate000SS: any = true;
   OrderDate000SS0: any = false;
   dateFromSu: any = new Date().toJSON().slice(0,10);
   dateToSu: any = new Date().toJSON().slice(0,10);
   dateFromSuAdmin: any = new Date().toJSON().slice(0,10);
   dateToSuAdmin: any = new Date().toJSON().slice(0,10);
   OrderDate000SSu: any = true;
   OrderDate000S0Su: any = false;
   OrderDate000SSSu: any = true;
   OrderDate000SS0Su: any = false;
   arreNo00: any;
   yarbs: any = null;
   yarbs000: any = 'All';
   yarbs000All: any = 'All';
   yarbs000All0: any = 'All';
   yarbs000All0Sales: any = 'All';
   yarbsS: any = 'All';
   dateFromCustomer: any = new Date().toJSON().slice(0,10);
   dateToCustomer: any = new Date().toJSON().slice(0,10);
   OrderDate000SCustomer: any = true;
   OrderDate000S0Customer: any = false;
   OrderDate000SSCustomer: any = true;
   OrderDate000SS0Customer: any = false;
   dateFromStore: any = new Date().toJSON().slice(0,10);
   dateToStore: any = new Date().toJSON().slice(0,10);
   OrderDate000SStore: any = true;
   OrderDate000S0Store: any = false;
   OrderDate000SSStore: any = true;
   OrderDate000SS0Store: any = false;
   dateFromBarcode: any = 'All';
   dateToBarcode: any;
   OrderDate000SBarcode: any = true;
   OrderDate000S0Barcode: any = false;
   OrderDate000SSBarcode: any = true;
   OrderDate000SS0Barcode: any = false;
   nameSubPri: any = 'All';
   nameSubPri1: any = 'All';
   nameStore: any = 'All';
   namePr: any = 'All';
   cityPr: any = 'All';
   adressPr: any = 'All';
   sumSales: any = 0;
   sumIn: any = 0;
   sumOut: any = 0;
   sumAvaliable: any = 0;
   sumSales1: any = 0;
   sumIn1: any = 0;
   sumOut1: any = 0;
   sumAvaliable1: any = 0;
   type: any;
   typeStore: any;
   typeCustomer: any;
   nameCustomerSales: any = 'All';
   dateSales: any = 'All';
   adreesCustomerSaled: any = 'All';
   cityCustomerSaled: any = 'All';
   areeAllStore: any;
   areeAllSales: any;
   uniqueNames = [];
   searchsupplierCountry: any = 'All';
   searchsupplierCountry1: any = 'All';
   sumtotalCustomer: any = 0;
   cityStore: any = 'All';
   locationStore: any = 'All';
   codeStore: any = 'All';
   categoryStore: any = 'All';
   descriptionStore: any = 'All';
   sumtotalStore: any = 0;
   sumtotalStore1: any = 0;
   totalArea: any = 0;
   totalAreaAnother: any = 0;
   totalArea0: any = 0;
   totalArea00: any = 0;
   sumtotalCustomer11: any = 0;
   totalArea1: any = 0;
   sumtotalCustomer1122: any = 0;
   sumtotalCustomer11222: any = 0;
   sumtotalCustomer11223: any = 0;
   sumSales009: any = 0;

  constructor(private _ApiService: ApiService , private _Router: Router, private _AppComponent: AppComponent , private _SearchSupplierPipe: SearchSupplierPipe , private _SelectpinPipe: SelectpinPipe , private _DateComPipe: DateComPipe , private _PlaceSearchPipe: PlaceSearchPipe , private _SerchCodePipe: SerchCodePipe , private _CustomerIdPipe: CustomerIdPipe , private _SamedatePipe: SamedatePipe , private _AreaFilterPipe: AreaFilterPipe , private _DateComOrderPipe: DateComOrderPipe , private _OrderOnlyPipe: OrderOnlyPipe , private _CategorySearchPipe: CategorySearchPipe , private _QuotationBillPipe: QuotationBillPipe , private _CountrySearchPipe: CountrySearchPipe , private _IdCustomerPipe: IdCustomerPipe ) {
    this._AppComponent.activeU = '';
    this._AppComponent.activeR = '';
    this._AppComponent.activeS = '';
    this._AppComponent.activeC = '';
    this._AppComponent.activeI = '';
    this._AppComponent.activeP = '';
    this._AppComponent.activeCu = '';
    this._AppComponent.activeCR = '';
    this._AppComponent.activeH = '';
    this._AppComponent.activeO = '';
    this._AppComponent.activeCE = '';
    this._AppComponent.activeCV = '';
    this._AppComponent.activeSE = '';
    this._AppComponent.activeSEB = '';
    this._AppComponent.activeCuO = '';
    this._AppComponent.activeCuOStore = '';
    this._AppComponent.activeHRE = '';
    this._AppComponent.activeHReport = '';
    this._AppComponent.activeHReportPrivate = '';
    this._AppComponent.activeHReportPrivatePaymentsReport = 'active';
    this._ApiService.allCustomerNot().subscribe((res)=>{
      if(res.check === true){
        this.arreNo00 = res.data;
        this.ngOnInit();
      } else{
        alert('error')
      }
    })
    this._ApiService.allCustomer().subscribe((res)=>{
      if(res.check === true){
        this.areeAllStore = res.data;
        this.ngOnInit();
      } else{
        alert('error')
      }
    })
    this._ApiService.allCustomerAllSales().subscribe((res)=>{
      if(res.check === true){
        this.areeAllSales = res.data;
        this.ngOnInit();
      } else{
        alert('error')
      }
    })
    this._ApiService.allpaynoPay().subscribe((res)=>{
      this.arrePayment = res;
      this.ngOnInit();
    })
    this._ApiService.allpayno().subscribe((res)=>{
      this.paynoArr = res;
      this.ngOnInit();
    })
    this._ApiService.allSC0().subscribe((res)=>{
      if(res.check === true){
        this.arreCustomer = res.data;
        this.ngOnInit();
      } else{
        alert('error')
      }
    })
    this._ApiService.allCa().subscribe((res)=>{
      this.allCa = res;
      this.ngOnInit();
    })
    this._ApiService.allS().subscribe((res)=>{
      if(res.check === true){
        this.supplierA = res.data;
        this.ngOnInit();
      } else{

        alert('error')
      }
    })
    this._ApiService.getRoots().subscribe((res)=>{
      this.rootA = res;
      this.ngOnInit();
    })
    this._ApiService.getControls().subscribe((res)=>{
      this.controlA = res;
      this.ngOnInit();
    })

    this._ApiService.Profile().subscribe((res)=>{
      if(res.check === true) {
        res.data.forEach((element: any) => {
          if(element.name == 'Reports') {
            if(element.	add_permission === 1) {
              this.add = true;
            }
            if(element.	update_permission === 1) {
              this.update = true;
            }
            if(element.	delete_permission === 1) {
              this.delete = true;
            }
          }

        });
        this._AppComponent.refreshNotification()
        this.show = true;
        this.ngOnInit();
      } else {

        this._Router.navigate([''])
        this.show = false;
      }
    })
    this._ApiService.allI().subscribe((res)=>{
      if(res.check === true){
        this.arre = res.data;
        this.arreParcode = res.data;
        this.arreStore = res.data;
        this.sumSales = 0;
        this.arre.forEach((element: any) => {
          this.sumSales = this.sumSales + element.sales;
        });
        // this._AppComponent.sumSales = this.sumSales;
        // this._AppComponent.showI1 = true

        this.ngOnInit();
        $('.loading').css({display: 'none'});
      } else{

        alert('error')
      }
    })
    this._ApiService.allIB().subscribe((res)=>{
      if(res.check === true){
        this.arreReportCustomer = res.data;
        this.ngOnInit();
        console.log(this.arreReportCustomer)
      } else{

        alert('error')
      }
    })
    this._AppComponent.goProfile();
   }
   sho(arr: any , id: any){
     arr.forEach((element: any) => {
       if(element.id == id){
         this.piNo = element.pinoS;
         this.go = true;
       }

     });
   }
   closeUpI(){
    $('#upd-up').css({display: 'none'});
    this.descriptionU = '';
    this.dimensionsU = '';
    this.fabricU = '';
    this.categoryU = '';
    this.qtyU = '';
    this.priceU = '';
    this.supplierU = '';
    this.rootU0 = '';
    this.paynoU = '';
    // this.codeOutU = '';
    this.oldSupplier = '';
    this.arrI = '';
    this.imgget = false;
    this.images = '';
    this.defectU = '';
    $(`.but0`).css({display: 'none'})
  }
  upI(data: any){
    this.imageShowU = true;
    this.imageShowA = false;
    this.descriptionU = data.description;
    this.dimensionsU = data.dimensions;
    this.fabricU = data.fabric;
    this.categoryU = data.category;
    this.qtyU = data.qty;
    this.priceU = data.price;
    this.supplierU = data.supplier;
    this.rootU0 = data.place;
    this.idUpI = data.id;
    this.paynoU = data.piNo;
    this.defectU= data.defect;
    this.notesU = data.notes;

    this.arrI = data.images;
    // this.codeOutU = data.codeOut;
    this.oldSupplier = data.supplier;
    $('#upd-up').css({display: 'block'});
    this.imgget = true;
    /*this._ApiService.allIm({id: data.id}).subscribe((res)=>{
      if(res.data.length == 0) {
        $('.loading').css({display: 'none'});
      } else{
         this.arrI = res.data;
         this.imgget = true;
        $('.loading').css({display: 'none'});
      }
    })*/
  }
  okUp(data: any){
    data.id = this.idUpI;
    data.oldSupplier = this.oldSupplier;
    if(this.descriptionU == '' || this.dimensionsU == '' || this.fabricU == '' || this.rootU0 == '' || this.descriptionU == undefined || this.dimensionsU == undefined || this.fabricU == undefined || this.rootU0 == undefined || this.qtyU == undefined ) {
      alert('Please enter all data completely');
    } else {
      $('.loading').css({display: 'block'});
      const formdata = new FormData();
      formdata.append('descriptionU', this.descriptionU);
      formdata.append('dimensionsU', this.dimensionsU);
      formdata.append('fabricU', this.fabricU);
      formdata.append('rootU0', this.rootU0);
      formdata.append('qtyU', this.qtyU);
      formdata.append('id', this.idUpI);
      formdata.append('defectU', this.defectU);
      formdata.append('notesU', this.notesU);

      for (let x of this.images) {
        formdata.append('images', x);
      }
    this._ApiService.updateI(formdata).subscribe((res)=> {
      if(res === true) {
        this._ApiService.allI().subscribe((res)=>{
          this.arre = res.data;
          // alert('Updated Done Successfully');
          this.closeUpI();
          this.sumSales = 0;
          this.arre.forEach((element: any) => {
            this.sumSales = this.sumSales + element.sales;
          });
          // this._AppComponent.sumSales = this.sumSales;
        // this._AppComponent.showI1 = true

        $('.loading').css({display: 'none'});
        })
      } else {
        alert("Updated Don't Successfully");
        this.closeUpI();
        $('.loading').css({display: 'none'});

      }
    })
    }
  }
   delI(id: any){
    $('#upd-dd').css({display: 'block'});
    this.idDI = id;
  }
  closedd(){
    $('#upd-dd').css({display: 'none'});
    this.idDI = '';
  }
  ok(){
    $('.loading').css({display: 'block'});
    var x = this.idDI;
    this._ApiService.delI({id: x}).subscribe((res)=>{
      if(res === true){
        this._ApiService.allI().subscribe((res)=>{
          this.arre = res.data;
          this.sumSales = 0;
          this.arre.forEach((element: any) => {
            this.sumSales = this.sumSales + element.sales;
          });
          // this._AppComponent.sumSales = this.sumSales;
        // this._AppComponent.showI1 = true

          alert('Deleted Done Successfully');
          this.closedd();
          $('.loading').css({display: 'none'});
        })
      } else {
        alert('Deleted Not Successfully\nPlease, if you want to delete this Item, you must delete all his pre request on the site');
        this.closedd();
        $('.loading').css({display: 'none'});
      }
    })
  }
  addI(){
    this.imageShowU = false;
    this.imageShowA = true;
    $('#upd').css({display: 'block'});
  }
  close(){
    $('#upd').css({display: 'none'});
    this.OrderDate00 = true;
    this.OrderDate01 = false;
    this.OrderDate000 = true;
    this.OrderDate010 = false;
    this.description = '';
    this.dimensions = '';
    this.fabric = '';
    this.category = '';
    this.qty = '';
    this.price = '';
    this.supplier = '';
    this.root = '';
    this.images = '';
    this.payno ='';
    this.codeOut = '';
    this.defect = '';
    this.notes = '';
    $('#select00I0').val('undefined').trigger('change.select2');
    $('#select00I').val('undefined').trigger('change.select2');
    $('#select00I00').val('undefined').trigger('change.select2');
    this.piNo = 0;
    $(`.but`).css({display: 'none'})
    this._ApiService.allS().subscribe((res)=>{
      if(res.check === true){
        this.supplierA = res.data;
        setTimeout(() => {
          $('#select00I').val('undefined').trigger('change.select2');
        }, 400);
      } else{

        alert('error')
      }
    })
  }
  OrderDate001() {
    this.OrderDate00 = false;
    this.OrderDate01 = true;
  }
  OrderDate0010() {
    this.OrderDate000 = false;
    this.OrderDate010 = true;
  }
  OrderDate00100() {
    $('#im0').trigger('click');
  }
  OrderDate001000() {
    $('#im0').trigger('click');
  }
  OrderDate0010000() {
    $('#im00').trigger('click');
  }
  OrderDate00100000() {
    $('#im00').trigger('click');
  }
  addS0(data: any){
    if(this.description == '' || this.dimensions == '' || this.fabric == '' || $('#select00I0').val() == '' || $('#select00I00').val() == '' || this.qty == '' || this.price == '' || $('#select00I').val() == '' || this.images == '' || this.dateorder == '' || this.datereceipt == '' || this.codeOut == '' || this.description == undefined || this.dimensions == undefined || this.fabric == undefined || $('#select00I0').val() == undefined || $('#select00I00').val() == undefined || this.qty == undefined || this.price == undefined || $('#select00I').val() == undefined || this.images == undefined || this.dateorder == undefined || this.codeOut == undefined || this.datereceipt == undefined ) {
      alert('Please enter all data completely');
    } else {
      $('.loading').css({display: 'block'});
      const formdata = new FormData();
      formdata.append('description', data.description);
      formdata.append('dimensions', data.dimensions);
      formdata.append('fabric', data.fabric);
      formdata.append('category', $('#select00I0').val());
      formdata.append('qty', data.qty);
      formdata.append('price', data.price);
      formdata.append('supplier', $('#select00I').val());
      formdata.append('root', $('#select00I00').val());
      formdata.append('payno', data.payno);
      formdata.append('codeOut', data.codeOut);
      formdata.append('dateorder', data.dateorder);
      formdata.append('datereceipt', data.datereceipt);
      formdata.append('defect', data.defect);
      formdata.append('notes', data.notes);
      for (let x of this.images) {
        formdata.append('images', x);
      }
    this._ApiService.addI(formdata).subscribe((res)=>{
      if(res.check === true){
        this._ApiService.allI().subscribe((res0)=>{
          if(res0.check === true){
            this.arre = res0.data;
            this.serchCode = this.arre[0].code
            this.serchCode00 = this.arre[0].code;
            this.sumSales = 0;
            this.arre.forEach((element: any) => {
              this.sumSales = this.sumSales + element.sales;
            });
            // this._AppComponent.sumSales = this.sumSales;
        // this._AppComponent.showI1 = true

            // alert('Added successfully');
            this.close();
            $('.loading').css({display: 'none'});
          } else{
            alert('error');

          }
        })
      } else {
        alert('Not added successfully');
        this.close();
        $('.loading').css({display: 'none'});

      }
    })
    }
  }
  img(event: any){
    this.countImage = $('#im0')[0].files;
    for(let x = 0 ; x < $('#im0')[0].files.length ; x++){
      const file = new FileReader();
      file.readAsDataURL($('#im0')[0].files[x]);
      file.onload = (oo: any)=>{
      $(`#put44${x}`).attr('src', oo.target.result);
      $(`#but${x} i`).css('display', 'none');
      $(`.but`).css({display: 'inline-block'})
    }
    }
    this.images = event.target.files;
  }
  img0(event: any){
    this.countImage0 = $('#im00')[0].files;
    for(let x = 0 ; x < $('#im00')[0].files.length ; x++){
      const file = new FileReader();
      file.readAsDataURL($('#im00')[0].files[x]);
      file.onload = (oo: any)=>{
      $(`#put440${x}`).attr('src', oo.target.result);
      $(`#but0${x} i`).css('display', 'none');
      $(`.but0`).css({display: 'inline-block'})
    }
    }
    this.images = event.target.files;
  }
  showpho(data: any){
    $('.loading').css({display: 'block'});
    this._ApiService.allIm({id: data}).subscribe((res)=>{
      if(res.data.length == 0) {
        alert('There are no images for this Item. Please go put pictures for this Item');
        $('.loading').css({display: 'none'});
      } else{
        this.arrImage = res.data;
        this.qwss = true;
        $('#updPho').css({display: 'block'});
        $('.loading').css({display: 'none'});
      }
    })
  }
  closePhot(){
    this.qwss = false;
    this.arrImage = '';
    $('#updPho').css({display: 'none'});
  }

  goFile(event: any){
    this.excel = event.target.files;
  }

  addIF(){
    $('#updF').css({display: 'block'});
  }
  closeF(){
    $('#updF').css({display: 'none'});
    this.supplier = '';
    this.excel = '';
    this.OrderDate00 = true;
    this.OrderDate01 = false;
    this.OrderDate000 = true;
    this.OrderDate010 = false;
    this.piNo = 0;
    this._ApiService.allS().subscribe((res)=>{
      if(res.check === true){
        this.supplierA = res.data;
        setTimeout(() => {
          $('#select00IJJ').val('undefined').trigger('change.select2');
        }, 400);
      } else{

        alert('error')
      }
    })
  }

  al(value: any) {
    alert(value);
  }

  addS0F(data: any){
    let supplier: string = $('.addSoClassName').val();
    this.supplier = supplier;
    data.supplier = supplier;
    //
    if($('#select00IJJ').val() == '' || this.excel == '' || this.dateorder == '' || this.datereceipt == '' || $('#select00IJJ').val() == undefined || this.excel == undefined || this.dateorder == undefined || this.datereceipt == undefined ) {
      alert('Please enter all data completely');
    } else {
      $('.loading').css({display: 'block'});
      const formdata = new FormData();
      formdata.append('supplier', $('#select00IJJ').val());
      formdata.append('dateorder', data.dateorder);
      formdata.append('datereceipt', data.datereceipt);
      formdata.append('excel', this.excel[0]);
    this._ApiService.addIF(formdata).subscribe((res)=>{
      if(res.check === true){
        this._ApiService.allI().subscribe((res0)=>{
          if(res0.check === true){
            this.arre = res0.data;
            this.serchCode = '';
            this.serchCode00 = '';
            this.searchsupplier = this.arre[0].supplier;
            this.selectpin = this.arre[0].pino;
            this.sumSales = 0;
            this.arre.forEach((element: any) => {
              this.sumSales = this.sumSales + element.sales;
            });
            // this._AppComponent.sumSales = this.sumSales;
        // this._AppComponent.showI1 = true

            // alert('تم الأضافه');
            this.closeF();
            $('.loading').css({display: 'none'});
          } else{
            alert('error');

          }
        })
      } else {
        alert('لم تتم الأضافة');
        this.closeF();
        $('.loading').css({display: 'none'});

      }
    })
    }
  }
  deleteImage(id: any ,  f: any) {
    $('.loading').css({display: 'block'});
    this._ApiService.deleteImage({id}).subscribe((res0)=>{
      if(res0 === true) {
        $(`.asd00${f}`).css({display: 'none'});
        alert('تم مسح الصورة');
        $('.loading').css({display: 'none'});
      }

    })
  }
  closeddP(){
    this.discoundPrint = '';
    $('#upd-ddO00').css({display: 'none'});
  }
  barcode(data: any) {
    JsBarcode("#barcode", `${data.code}`, {
      width: 8,
      height: 600,
      fontSize: 140,
      fontOptions: "bold"
    });
    this.categoryPrint = data.categoryname;
    this.dimPrint = data.dimensions;
    this.pricePrint = data.price;
    $('#upd-ddO00').css({display: 'block'});
  }
  dishav() {
    this.pricePrint0 = this.pricePrint - this.valDis ;
    this.discoundPrint = (1 - (this.pricePrint0 / this.pricePrint)) * 100;
  }
  dishav0() {
    this.pricePrint0 = this.pricePrint - (this.pricePrint * (this.discoundPrint / 100) ) ;
    this.valDis = this.pricePrint - this.pricePrint0 ;
  }
  okP() {
    if(this.discoundPrint == '' || this.discoundPrint == undefined) {
      this.dis0 = true;
      this.dis = false;
      $('.printch').hide();
    $('.supplierto').show();
      this.closeddP();
      $('#printall').css({display: 'block'});
      setTimeout(() => {
        window.print();
        $('.printch').show();
      $('.supplierto').hide();
        $('#printall').css({display: 'none'});
      }, 400);
    } else {
      this.pricePrint0 = this.pricePrint - (this.pricePrint * (this.discoundPrint / 100) ) ;
      this.dis = true;
      this.dis0 = false;
      $('.printch').hide();
    $('.supplierto').show();
      this.closeddP();
      $('#printall').css({display: 'block'});
      setTimeout(() => {
        window.print();
        $('.printch').show();
      $('.supplierto').hide();
        $('#printall').css({display: 'none'});
      }, 400);
    }
  }
  goDateBarcode() {
    this.dateToBarcode = $('#toDGBarcode').val();
    this.dateFromBarcode = $('#fromDGBarcode').val();
    this.pipeFilter2();
    // $('.loading').css({display: 'block'});
    // this._ApiService.allID({from: $('#fromDG').val(), to: $('#toDG').val()}).subscribe((res)=>{
    //   if(res.check === true){
    //     this.arre = res.data;
    //     $('.loading').css({display: 'none'});
    //   } else{
    //     alert('error')
    //     $('.loading').css({display: 'none'});

    //   }
    // })
  }
  goDateStore() {
    this.dateToStore = $('#toDGStore').val();
    this.dateFromStore = $('#fromDGStore').val();
    this.pipeFilter1();
    // $('.loading').css({display: 'block'});
    // this._ApiService.allID({from: $('#fromDG').val(), to: $('#toDG').val()}).subscribe((res)=>{
    //   if(res.check === true){
    //     this.arre = res.data;
    //     $('.loading').css({display: 'none'});
    //   } else{
    //     alert('error')
    //     $('.loading').css({display: 'none'});

    //   }
    // })
  }
  goDate000() {
    this.dateTo = $('#toDGStore').val();
    this.dateFrom = $('#fromDGStore').val();
    // $('.loading').css({display: 'block'});
    // this._ApiService.allID({from: $('#fromDG').val(), to: $('#toDG').val()}).subscribe((res)=>{
    //   if(res.check === true){
    //     this.arre = res.data;
    //     $('.loading').css({display: 'none'});
    //   } else{
    //     alert('error')
    //     $('.loading').css({display: 'none'});

    //   }
    // })
  }
  OrderDate0010S() {
    this.OrderDate000S = false;
    this.OrderDate000S0 = true;
    setTimeout(() => {
      $('.fromDAStore').val(new Date().toJSON().slice(0,10))
    }, 100);

  }
  OrderDate0010SS(){
    this.OrderDate000SS = false;
    this.OrderDate000SS0 = true;
    setTimeout(() => {
      $('.toDAStore').val(new Date().toJSON().slice(0,10));
    }, 100);
  }
  goDate() {
    this.dateToSu = $('#toDG').val();
    this.dateFromSu = $('#fromDG').val();
    console.log(this.dateToSu);
    this.pipeFilter();
    // $('.loading').css({display: 'block'});
    // this._ApiService.allID({from: $('#fromDG').val(), to: $('#toDG').val()}).subscribe((res)=>{
    //   if(res.check === true){
    //     this.arre = res.data;
    //     $('.loading').css({display: 'none'});
    //   } else{
    //     alert('error')
    //     $('.loading').css({display: 'none'});

    //   }
    // })
  }
  OrderDate0010SSu() {
    this.OrderDate000SSu = false;
    this.OrderDate000S0Su = true;
    setTimeout(() => {
      $('.fromDA').val(new Date().toJSON().slice(0,10))
    }, 100);

  }
  OrderDate0010SSSu(){
    this.OrderDate000SSSu = false;
    this.OrderDate000SS0Su = true;
    setTimeout(() => {
      $('.toDA').val(new Date().toJSON().slice(0,10));
    }, 100);
  }
  goDate1() {
    this.dateToCustomer = $('#toDG1').val();
    this.dateFromCustomer = $('#fromDG1').val();
    // $('.loading').css({display: 'block'});
    // this._ApiService.allIBD({from: $('#fromDG1').val(), to: $('#toDG1').val()}).subscribe((res)=>{
    //   if(res.check === true){
    //     this.arreReportCustomer = res.data;
    //     $('.loading').css({display: 'none'});
    //   } else{
    //     alert('error')
    //     $('.loading').css({display: 'none'});

    //   }
    // })
  }
  OrderDate0010SCustomer() {
    this.OrderDate000SCustomer = false;
    this.OrderDate000S0Customer = true;
    setTimeout(() => {
      $('.fromDA1').val(new Date().toJSON().slice(0,10))
    }, 100);

  }
  OrderDate0010SSCustomer(){
    this.OrderDate000SSCustomer = false;
    this.OrderDate000SS0Customer = true;
    setTimeout(() => {
      $('.toDA1').val(new Date().toJSON().slice(0,10));
    }, 100);
  }
  goDate2() {
    $('.loading').css({display: 'block'});
    this._ApiService.allIBDP({from: $('#fromDG2').val(), to: $('#toDG2').val()}).subscribe((res)=>{
      if(res.check === true){
        this.arreParcode = res.data;
        $('.loading').css({display: 'none'});
      } else{
        alert('error')
        $('.loading').css({display: 'none'});

      }
    })
  }
  OrderDate0010SStore() {
    this.OrderDate000SStore = false;
    this.OrderDate000S0Store = true;
    setTimeout(() => {
      $('.fromDAStore').val(new Date().toJSON().slice(0,10))
    }, 100);

  }
  OrderDate0010SSStore(){
    this.OrderDate000SSStore = false;
    this.OrderDate000SS0Store = true;
    setTimeout(() => {
      $('.toDAStore').val(new Date().toJSON().slice(0,10));
    }, 100);
  }
  OrderDate0010SBarcode() {
    this.OrderDate000SBarcode = false;
    this.OrderDate000S0Barcode = true;
    setTimeout(() => {
      $('.fromDABarcode').val(new Date().toJSON().slice(0,10))
    }, 100);

  }
  OrderDate0010SSBarcode(){
    this.OrderDate000SSBarcode = false;
    this.OrderDate000SS0Barcode = true;
    setTimeout(() => {
      $('.toDABarcode').val(new Date().toJSON().slice(0,10));
    }, 100);
  }
  goDate3() {
    $('.loading').css({display: 'block'});
    this._ApiService.allID({from: $('#fromDG3').val(), to: $('#toDG3').val()}).subscribe((res)=>{
      if(res.check === true){
        this.arreParcode = res.data;
        $('.loading').css({display: 'none'});
      } else{
        alert('error')
        $('.loading').css({display: 'none'});

      }
    })
  }
  goPic(v: any){
    this.goImg = true;
    this.www = v;
  }
  goPic0(){
    this.goImg = false;
    this.www = '';
  }
  printert(){
    $('#printall').css({display: 'none !important'})
    $('#printAll1').css({display: 'block !important'})
    window.print();
  }
  sfr(){
    // this.arre = [];
    this.serchCode = '0';
    this.serchCode00 = '0';
    this.searchsupplier = 'Search By Supplier';
    this.selectpin = 'undefined';
    this.pi = [];
  }
  sfr0(){
    this.serchCode = '';
    this.serchCode00 = '';
    $('.selectsearchroot000').val('undefined').trigger('change.select2');
    this.searchsupplier = 'Search By Supplier';
    this.pi = [];
    this.selectpin = 'undefined';
    $('.selectpin').val('undefined').trigger('change.select2');
    $('.selectsearchsupplier').val('Search By Company').trigger('change.select2');
    // this._ApiService.allI().subscribe((res)=>{
    //   if(res.check === true){
    //     this.arre = res.data;
    // this.arre.forEach((element: any) => {
    //   this.sumSales = this.sumSales + element.sales;
    // });
    // // this._AppComponent.sumSales = this.sumSales;
        // this._AppComponent.showI1 = true
    // this._AppComponent.showI1 = true
    //   } else{
    //     Helper.redirect(res, this._ApiService, this._Router, (res: any) =>{ this.sfr0() });
    //   }
    // })
  }
  printSupplier(){
      $('.supplier2').hide();
      $('.printch').hide();
    // $('.supplierto').show();
    setTimeout(() => {
      window.print();
      $('.printch').show();
    }, 400);
  }
  printStore(){
      $('.supplier2').hide();
      $('.printch').hide();
    // $('.supplierto').show();
    setTimeout(() => {
      window.print();
      $('.printch').show();
    }, 400);
  }
  printCustomer(){
    $('.printch').hide();
    $('.supplierto').show();
    $('.printCustomer').show();
    setTimeout(() => {
      window.print();
      $('.printch').show();
    }, 400);
  }
  piDestroy(){
    this.pi = [];
    this.pipeFilter();

  }
  piDestroy1(){
    this.pi = [];
    this.pipeFilter2();

  }
  salesOption(){
    this._AppComponent.showI1 = false;
  }
  salesOption2(){

    this.pipeFilter1();
  }
  pipeFilter() {
    this.sumSales = 0 ;
    this.sumIn = 0;
    this.sumOut = 0;
    this.sumAvaliable = 0;
    var x = this._SearchSupplierPipe.transform(this.arre , this.searchsupplierAdmin);
    var y = this._SelectpinPipe.transform(x , this.selectpinAdmin);
    var e = this._DateComPipe.transform(y , this.dateFromSu , this.dateToSu);
    var d = this._CountrySearchPipe.transform(e , this.searchsupplierCountry);
    d.forEach((element: any) => {
      this.sumSales = this.sumSales + element.sales;
      this.sumIn = this.sumIn + element.mainqty;
      this.sumOut = this.sumOut + element.qtyfinish;
      this.sumAvaliable = this.sumAvaliable + element.qty;
    });
    // this._AppComponent.sumSales = this.sumSales;
        // this._AppComponent.showI1 = true
        this.pipeAreaSales();

  }
  pipeFilter222() {
    this.sumSales009 = 0 ;
    var x = this._SearchSupplierPipe.transform(this.arreStore , this.searchsupplierAdmin1);
    var y = this._SelectpinPipe.transform(x , this.selectpinAdmin1);
    var e = this._CountrySearchPipe.transform(y , this.searchsupplierCountry1);
    var d = this._DateComPipe.transform(e , this.dateFromSuAdmin , this.dateToSuAdmin);
    d.forEach((element: any) => {
      this.sumSales009 = this.sumSales + (element.qty * element.price);
    });
    // this._AppComponent.sumSales = this.sumSales;
        // this._AppComponent.showI1 = true

  }
  pipeFilter12Admin() {
    this.sumSales1 = 0 ;
    this.sumIn1 = 0;
    this.sumOut1 = 0;
    this.sumAvaliable1 = 0;
    var x = this._SearchSupplierPipe.transform(this.arre , this.searchsupplierAdmin1);
    var y = this._SelectpinPipe.transform(x , this.selectpinAdmin1);
    var e = this._DateComPipe.transform(y , this.dateFromSuAdmin , this.dateToSuAdmin);
    var d = this._CountrySearchPipe.transform(e , this.searchsupplierCountry1);
    d.forEach((element: any) => {
      this.sumSales1 = this.sumSales1 + element.sales;
      this.sumIn1 = this.sumIn1 + element.mainqty;
      this.sumOut1 = this.sumOut1 + element.qtyfinish;
      this.sumAvaliable1 = this.sumAvaliable1 + element.qty;
    });
    // this._AppComponent.sumSales = this.sumSales;
        // this._AppComponent.showI1 = true

  }
  pipeFilterAdmin() {
    this.sumSales = 0 ;
    var x = this._SearchSupplierPipe.transform(this.arre , this.searchsupplierAdmin);
    var y = this._SelectpinPipe.transform(x , this.selectpinAdmin);
    var e = this._DateComPipe.transform(y , this.dateFromSuAdmin , this.dateToSuAdmin);
    e.forEach((element: any) => {
      this.sumSales = this.sumSales + element.sales;
    });
    // this._AppComponent.sumSales = this.sumSales;
        // this._AppComponent.showI1 = true

  }
  pipeFilterStore() {
    this.sumtotalStore = 0 ;
    var x = this._SerchCodePipe.transform(this.arreReportCustomer , this.serchCodeStore);
    var e = this._DateComPipe.transform(x , this.dateFromStore , this.dateToStore);
    var y = this._PlaceSearchPipe.transform(e , this.placeSearchStore);
    y.forEach((element: any) => {
      this.sumtotalStore = this.sumtotalStore + element.qty;
    });
  }
  pipeFilterStore1() {
    this.sumtotalStore1 = 0 ;
    var x = this._SerchCodePipe.transform(this.arreStore , this.serchCodeStore);
    var e = this._DateComPipe.transform(x , this.dateFromStore , this.dateToStore);
    var y = this._PlaceSearchPipe.transform(e , this.placeSearchStore);
    y.forEach((element: any) => {
      this.sumtotalStore1 = this.sumtotalStore1 + (element.qty * element.price);
    });
    if(this.sumtotalStore1 == '' || this.sumtotalStore1 == null || this.sumtotalStore1 == undefined || this.sumtotalStore1 == 0){

    } else {
    var xx = parseInt(this.sumtotalStore1);
    var yy = xx.toLocaleString()
    var b = yy.toString()
    this.sumtotalStore1 = b;
    }

  }
  pipeAreaSales() {
    this.totalArea = 0 ;
    var e = this._DateComOrderPipe.transform(this.areeAllSales , this.dateFrom , this.dateTo);
    var y = this._OrderOnlyPipe.transform(e);
    y.forEach((element: any) => {
      this.totalArea = this.totalArea + ( element.totalprice - (element.totalprice * (element.discound / 100) ));
    });
  }
  pipeAreaSalesAnother() {
    this.totalAreaAnother = 0 ;
    var x = this._AreaFilterPipe.transform(this.areeAllSales , this.yarbs000All0Sales);
    var e = this._DateComOrderPipe.transform(x , this.dateFromAnoter , this.dateToAnoter);
    var y = this._OrderOnlyPipe.transform(e);
    y.forEach((element: any) => {
      this.totalAreaAnother = this.totalAreaAnother + ( element.totalprice - (element.totalprice * (element.discound / 100) ));
    });
  }
  pipeAreaSales0() {
    this.totalArea0 = 0 ;
    var e = this._DateComOrderPipe.transform(this.areeAllSales , this.dateFromCustomer , this.dateToCustomer);
    var y = this._OrderOnlyPipe.transform(e);
    var x = this._CustomerIdPipe.transform(y , this.yarbsS);
    x.forEach((element: any) => {
      this.totalArea0 = this.totalArea0 + ( element.totalprice - (element.totalprice * (element.discound / 100) ));
    });
  }
  pipeFilterSupplier() {
    this.totalArea00 = 0 ;
    var e = this._DateComPipe.transform(this.arreReportCustomer , this.dateFromSu , this.dateToSu);
    var y = this._OrderOnlyPipe.transform(e);
    var x = this._SearchSupplierPipe.transform(y , this.searchsupplierAdmin);
    x.forEach((element: any) => {
      this.totalArea00 = this.totalArea00 + element.qty ;
    });
  }
  pipeAreaSales1() {
    this.totalArea1 = 0 ;
    var e = this._DateComOrderPipe.transform(this.areeAllSales , this.dateFrom , this.dateTo);
    var y = this._OrderOnlyPipe.transform(e);
    y.forEach((element: any) => {
      this.totalArea1 = this.totalArea1 + ( element.totalprice - (element.totalprice * (element.discound / 100) ));
    });
  }
  pipeFilterCustomer1() {
    this.sumtotalCustomer11 = 0 ;
    var x = this._DateComOrderPipe.transform(this.arreReportCustomer , this.dateFrom , this.dateTo);
    var e = this._CategorySearchPipe.transform(x , this.categorySearch);
    var y = this._OrderOnlyPipe.transform(e);
    y.forEach((element: any) => {
      this.sumtotalCustomer11 = this.sumtotalCustomer11 + element.qty;
    });
  }
  pipeFilterCustomer11() {
    this.sumtotalCustomer1122 = 0 ;
    var e = this._QuotationBillPipe.transform(this.arreReportCustomer , this.yarbs000All0);
    e.forEach((element: any) => {
      this.sumtotalCustomer1122 = this.sumtotalCustomer1122 + element.total;
    });
  }
  pipeFilterCustomer13() {
    this.sumtotalCustomer11223 = 0 ;
    var e = this._QuotationBillPipe.transform(this.arreReportCustomer , this.yarbs000);
    e.forEach((element: any) => {
      this.sumtotalCustomer11223 = this.sumtotalCustomer11223 + element.total;
    });
  }
  pipeFilterCustomer12() {
    this.sumtotalCustomer11222 = 0 ;
    var e = this._QuotationBillPipe.transform(this.arreReportCustomer , this.yarbs000All);
    e.forEach((element: any) => {
      this.sumtotalCustomer11222 = this.sumtotalCustomer1122 + element.total;
    });
  }
  pipeFilterCustomer() {
    this.sumtotalCustomer = 0 ;
    var x = this._IdCustomerPipe.transform(this.arreReportCustomer , this.yarbsS);
    var e = this._SamedatePipe.transform(x , this.dateFromCustomer , this.dateToCustomer);
    e.forEach((element: any) => {
      this.sumtotalCustomer = this.sumtotalCustomer + element.total;
    });
  }
  pipeFilter1() {
    this.sumSales = 0 ;
    var x = this._SerchCodePipe.transform(this.arre , this.serchCodeStore);
    var y = this._PlaceSearchPipe.transform(x , this.placeSearchStore);
    var e = this._DateComPipe.transform(y , this.dateFromStore , this.dateToStore);
    e.forEach((element: any) => {
      this.sumSales = this.sumSales + element.sales;
    });
    // this._AppComponent.sumSales = this.sumSales;
        // this._AppComponent.showI1 = true

  }
  pipeFilter2() {
    this.sumSales = 0 ;
    var x = this._SerchCodePipe.transform(this.arre , this.serchCode00);
    var y = this._SearchSupplierPipe.transform(x , this.searchsupplierBar);
    var d = this._SelectpinPipe.transform(y , this.selectpinBar);
    var e = this._DateComPipe.transform(d , this.dateFromBarcode , this.dateToBarcode);
    e.forEach((element: any) => {
      this.sumSales = this.sumSales + element.sales;
    });
    // this._AppComponent.sumSales = this.sumSales;
        // this._AppComponent.showI1 = true

  }
  showSupplier1Admin2(type: any) {
    this.pipeFilter12Admin();
    if(type === 'In') {
      this.type = 'In';
      $('.country').show();
      $('td:nth-child(2),th:nth-child(2)').hide();
      $('td:nth-child(3),th:nth-child(3)').hide();
      $('td:nth-child(4),th:nth-child(4)').hide();
      $('td:nth-child(7),th:nth-child(7)').hide();
      $('td:nth-child(8),th:nth-child(8)').hide();
      $('td:nth-child(11),th:nth-child(11)').hide();
      $('td:nth-child(13),th:nth-child(13)').hide();
      $('td:nth-child(14),th:nth-child(14)').hide();
      $('td:nth-child(15),th:nth-child(15)').hide();
      $('.goSupplierAdmin2').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
      $('.supplier2').hide();
      $('.supplier3').hide();
      $('.supplier4').hide();
    } else if(type === 'Items1') {
      this.type = 'Items1';
      $('.country').show();
      $('td:nth-child(9),th:nth-child(9)').hide();
      $('td:nth-child(10),th:nth-child(10)').hide();
      $('td:nth-child(11),th:nth-child(11)').hide();
      $('td:nth-child(12),th:nth-child(12)').hide();
      $('td:nth-child(13),th:nth-child(13)').hide();
      $('td:nth-child(14),th:nth-child(14)').hide();
      $('td:nth-child(15),th:nth-child(15)').hide();
      $('.goSupplierAdmin2').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
      $('.supplier1').hide();
      $('.supplier2').hide();
      $('.supplier3').hide();
      $('.supplier4').hide();
      $('.supplier5').hide();
      $('.supplier6').hide();
      $('.supplier2').hide();
      $('.supplier2a').hide();
      $('.supplier2b').hide();
      $('.supplier2c').hide();
      $('.supplierDir').hide();
    }
    else if(type === 'Items2') {
      $('.country').show();
      this.type = 'Items2';
      $('td:nth-child(2),th:nth-child(2)').hide();
      $('td:nth-child(7),th:nth-child(7)').hide();
      $('td:nth-child(9),th:nth-child(9)').hide();
      $('td:nth-child(10),th:nth-child(10)').hide();
      $('td:nth-child(11),th:nth-child(11)').hide();
      $('td:nth-child(12),th:nth-child(12)').hide();
      $('td:nth-child(13),th:nth-child(13)').hide();
      $('td:nth-child(14),th:nth-child(14)').hide();
      $('td:nth-child(15),th:nth-child(15)').hide();
      $('.goSupplierAdmin2').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
      $('.supplier2').hide();
      $('.supplier2a').hide();
      $('.supplier2b').hide();
      $('.supplier2c').hide();
      $('.supplierDir').hide();
    }
  }
  showSupplier1(type: any) {
    this.pipeFilter();
    if(type === 'In') {
      this.type = 'In';
      $('.country').show();
      $('td:nth-child(2),th:nth-child(2)').hide();
      $('td:nth-child(3),th:nth-child(3)').hide();
      $('td:nth-child(4),th:nth-child(4)').hide();
      $('td:nth-child(7),th:nth-child(7)').hide();
      $('td:nth-child(8),th:nth-child(8)').hide();
      $('td:nth-child(11),th:nth-child(11)').hide();
      $('td:nth-child(13),th:nth-child(13)').hide();
      $('td:nth-child(14),th:nth-child(14)').hide();
      $('td:nth-child(15),th:nth-child(15)').hide();
      $('.goSupplier').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
      $('.supplier2').hide();
      $('.supplier3').hide();
      $('.supplier4').hide();
    } else if(type === 'Period') {
      this.type = 'Period';
      $('.supplierto').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.goSupplierinvoice').css({display: 'block'});
      $('.supplier7').hide();
      $('.supplier6').hide();
      $('.supplier5').hide();
      $('.supplier2').hide();
      $('.country').show();
    } else if(type === 'Items1') {
      this.type = 'Items1';
      $('.country').show();
      $('td:nth-child(9),th:nth-child(9)').hide();
      $('td:nth-child(10),th:nth-child(10)').hide();
      $('td:nth-child(11),th:nth-child(11)').hide();
      $('td:nth-child(12),th:nth-child(12)').hide();
      $('td:nth-child(13),th:nth-child(13)').hide();
      $('td:nth-child(14),th:nth-child(14)').hide();
      $('td:nth-child(15),th:nth-child(15)').hide();
      $('.goSupplier').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
      $('.supplier1').hide();
      $('.supplier2').hide();
      $('.supplier3').hide();
      $('.supplier4').hide();
      $('.supplier5').hide();
      $('.supplier6').hide();
      $('.supplier2').hide();
      $('.supplier2a').hide();
      $('.supplier2b').hide();
      $('.supplier2c').hide();
      $('.supplierDir').hide();
    }
    else if(type === 'Items2') {
      $('.country').show();
      this.type = 'Items2';
      $('td:nth-child(2),th:nth-child(2)').hide();
      $('td:nth-child(7),th:nth-child(7)').hide();
      $('td:nth-child(9),th:nth-child(9)').hide();
      $('td:nth-child(10),th:nth-child(10)').hide();
      $('td:nth-child(11),th:nth-child(11)').hide();
      $('td:nth-child(12),th:nth-child(12)').hide();
      $('td:nth-child(13),th:nth-child(13)').hide();
      $('td:nth-child(14),th:nth-child(14)').hide();
      $('td:nth-child(15),th:nth-child(15)').hide();
      $('.goSupplier').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
      $('.supplier2').hide();
      $('.supplier2a').hide();
      $('.supplier2b').hide();
      $('.supplier2c').hide();
      $('.supplierDir').hide();
    }
  }
  goSalesInvoice(type: any) {
    this.pipeFilterCustomer1();
    this.pipeFilterCustomer11();
    this.pipeFilterCustomer12();
    this.pipeFilterCustomer13();
    this.pipeAreaSales();
    this.pipeAreaSales1();
    if(type === 'ShowQuotation') {
      this.yarbs000All = 'All';
      $('.select2QAll').val('All').trigger('change.select2');
      this.yarbs000All0 = 'All';
      $('.select2QAll0').val('All').trigger('change.select2');
      $('.goSalesInvoice').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
    } else if(type === 'ShowQuotation00') {
      this.yarbs000 = 'All';
      $('.select2Q').val('All').trigger('change.select2');
      this.yarbs000All0 = 'All';
      $('.select2QAll0').val('All').trigger('change.select2');
      $('.goSalesInvoiceHold').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
    } else if(type === 'salesInvoice1') {
      $('.salesInvoice').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
    } else if(type === 'goSalesAll00') {
      this.yarbs000 = 'All';
      $('.select2Q').val('All').trigger('change.select2');
      this.yarbs000All = 'All';
      $('.select2QAll').val('All').trigger('change.select2');
      $('.goSalesAll00').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
    } else if(type === 'goSalesInvoiceCategory') {
      $('.goSalesInvoiceCategory').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
    } else if(type === 'salesInvoiceAll') {
      $('.salesInvoiceAll').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
    }
  }
  showSupplier1Store(type: any) {
    this.pipeFilterStore();
    this.pipeFilterStore1();
    if(type === 'All Items') {
      this.typeStore = 'All Items';
      $('td:nth-child(4),th:nth-child(4)').hide();
      $('td:nth-child(9),th:nth-child(9)').hide();
      $('td:nth-child(10),th:nth-child(10)').hide();
      $('td:nth-child(11),th:nth-child(11)').hide();
      $('td:nth-child(12),th:nth-child(12)').hide();
      $('.goStore').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
      $('.store2').hide();
      $('.allQtyShow').hide();
      $('.TotalPrice').show();
    } else if(type === 'StorePeriod') {
      this.typeStore = 'StorePeriod';
      $('td:nth-child(5),th:nth-child(5)').hide();
      $('td:nth-child(6),th:nth-child(6)').hide();
      $('td:nth-child(8),th:nth-child(8)').hide();
      $('td:nth-child(9),th:nth-child(9)').hide();
      $('td:nth-child(10),th:nth-child(10)').hide();
      $('td:nth-child(11),th:nth-child(11)').hide();
      $('.goStore').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
      $('.store2').hide();
      $('.allQtyShow').hide();
      $('.TotalPrice').hide();
    } else if(type === 'goStoreInvoice') {
      this.typeStore = 'goStoreInvoice';
      $('td:nth-child(5),th:nth-child(5)').hide();
      $('td:nth-child(8),th:nth-child(8)').hide();
      $('.goStoreInvoice').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
      $('.store2').hide();
      $('.allQtyShow').hide();
    } else if(type === 'goStoreInvoice2') {
      this.typeStore = 'goStoreInvoice2';
      $('td:nth-child(5),th:nth-child(5)').hide();
      $('td:nth-child(8),th:nth-child(8)').hide();
      $('td:nth-child(6),th:nth-child(6)').hide();
      $('td:nth-child(7),th:nth-child(7)').hide();
      $('.goStoreInvoice').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
      $('.store2').hide();
      $('.allQtyShow').show();
    }
  }
  showCustomer(type: any) {
    this.pipeFilterCustomer();
    if(type === 'Customer') {
      this.typeCustomer = 'Customer';
      $('.goCustomer').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
      // $('.store2').hide();
    }
  }
  returnNewCustomer() {
    $('.goCustomer').css({display: 'none'});
    $('.navMaker').css({display: 'block'});
  }
  returnNew() {
    $('.goSupplierAdmin2').css({display: 'none'});
    $('.goSupplier').css({display: 'none'});
    $('.goSupplierinvoice').css({display: 'none'});
    $('.navMaker').css({display: 'block'});
    $('.supplier1').show();
    $('.supplier2').show();
    $('.supplier3').show();
    $('.supplier4').show();
    $('.supplier5').show();
    $('.supplier6').show();
    $('.supplier7').show();
    $('.supplier2a').show();
      $('.supplier2b').show();
      $('.supplier2c').show();
      $('.supplierDir').show();
    $('td:nth-child(1),th:nth-child(1)').show();
    $('td:nth-child(2),th:nth-child(2)').show();
      $('td:nth-child(3),th:nth-child(3)').show();
      $('td:nth-child(4),th:nth-child(4)').show();
      $('td:nth-child(5),th:nth-child(5)').show();
      $('td:nth-child(6),th:nth-child(6)').show();
      $('td:nth-child(7),th:nth-child(7)').show();
      $('td:nth-child(8),th:nth-child(8)').show();
    $('td:nth-child(9),th:nth-child(9)').show();
      $('td:nth-child(10),th:nth-child(10)').show();
      $('td:nth-child(11),th:nth-child(11)').show();
      $('td:nth-child(12),th:nth-child(12)').show();
      $('td:nth-child(13),th:nth-child(13)').show();
      $('td:nth-child(14),th:nth-child(14)').show();
      $('td:nth-child(15),th:nth-child(15)').show();
  }
  returnStore(){
    for(let i = 0 ; i < 15 ; i++){
      $(`td:nth-child(${i}),th:nth-child(${i})`).show();
    }
    $('.goStoreInvoice').css({display: 'none'});
    $('.goStore').css({display: 'none'});
    $('.navMaker').css({display: 'block'});
    $('.allQtyShow').show();
    $('.goStoreAdmin').css({display: 'none'});
  }
  returnSales(){
    for(let i = 0 ; i < 15 ; i++){
      $(`td:nth-child(${i}),th:nth-child(${i})`).show();
    }
    $('.salesInvoice').css({display: 'none'});
    $('.goSalesInvoice').css({display: 'none'});
    $('.navMaker').css({display: 'block'});
    $('.goSalesInvoiceHold').css({display: 'none'});
    $('.goSalesAll00').css({display: 'none'});
    $('.goSalesInvoiceCategory').css({display: 'none'});
    $('.salesInvoiceAll').css({display: 'none'});
  }
  showSupplier1Admin(type: any) {
    if(type == 'goSupplierinvoiceAdmin'){
      $('.goSupplierinvoiceAdmin').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
    } else if(type == 'goStoreAdmin'){
      this.pipeFilter222();
      $('.goStoreAdmin').css({display: 'block'});
      $('.navMaker').css({display: 'none'});
      $('.supplierto').show();
    }
  }
  returnNewAdmin() {
    $('.goSupplierAdmin').css({display: 'none'});
    $('.goSupplierinvoiceAdmin').css({display: 'none'});
    $('.goStoreAdmin').css({display: 'none'});
    $('.navMaker').css({display: 'block'});
  }
  ngOnInit(): void {
    let self = this;
    // setTimeout(() => {
      $('.select2, .js-example-basic-multiple').select2();
      $('.selectpin0').on('select2:select', function (e: any) {
        self.categorySearch = $('.selectpin0').val();
      });
      $('#select00I').on('select2:select', function (e: any) {
        self.sho(self.supplierA, $('#select00I').val());
      });
      $('#select00IJJ').on('select2:select', function (e: any) {
        self.sho(self.supplierA, $('#select00IJJ').val());
      });
      $('.selectsearchsupplier').on('select2:select', function (e: any) {
        self.pi = [];
        $('.selectpin').val('undefined').trigger('change.select2');
        self.selectpin = 'All';
        self.searchsupplier = $('.selectsearchsupplier').val()
        self.pipeFilter()
        self.supplierA.forEach((element: any) => {
          if(element.id == $('.selectsearchsupplier').val()){
            self.nameSubPri = element.name;
            for(var i = 0 ; i < element.pinoS ; i++) {
              self.pi.push(' ');
            }
          } else if ($('.selectsearchsupplier').val() === 'All') {
            self.nameSubPri = 'All';
          }
        });
      });
      $('.searchsupplierAdmin').on('select2:select', function (e: any) {
        self.piAdmin = [];
        $('.selectpinAdmin').val('undefined').trigger('change.select2');
        self.selectpinAdmin = 'All';
        self.searchsupplierAdmin = $('.searchsupplierAdmin').val()
        self.pipeFilterAdmin()
        self.supplierA.forEach((element: any) => {
          if(element.id == $('.searchsupplierAdmin').val()){
            self.nameSubPri = element.name;
            for(var i = 0 ; i < element.pinoS ; i++) {
              self.piAdmin.push(' ');
            }
          } else if ($('.searchsupplierAdmin').val() === 'All') {
            self.nameSubPri = 'All';
          }
        });
        self.pipeFilterSupplier();
      });
      $('.searchsupplierAdmin1').on('select2:select', function (e: any) {
        self.piAdmin1 = [];
        $('.selectpinAdmin1').val('undefined').trigger('change.select2');
        self.selectpinAdmin1 = 'All';
        self.searchsupplierAdmin1 = $('.searchsupplierAdmin1').val()
        self.pipeFilterAdmin()
        self.supplierA.forEach((element: any) => {
          if(element.id == $('.searchsupplierAdmin1').val()){
            self.nameSubPri1 = element.name;
            for(var i = 0 ; i < element.pinoS ; i++) {
              self.piAdmin1.push(' ');
            }
          } else if ($('.searchsupplierAdmin1').val() === 'All') {
            self.nameSubPri1 = 'All';
          }
        });
      });
      $('.selectsearchsupplierBar').on('select2:select', function (e: any) {
        self.pi = [];
        $('.selectpinBar').val('undefined').trigger('change.select2');
        self.selectpinBar = 'All';
        self.searchsupplierBar = $('.selectsearchsupplierBar').val()
        self.pipeFilter2();
        self.supplierA.forEach((element: any) => {
          if(element.id == $('.selectsearchsupplierBar').val()){
            for(var i = 0 ; i < element.pinoS ; i++) {
              self.pi.push(' ');
            }
          }
        });
      });
      $('.selectsearchroot').on('select2:select', function (e: any) {
        self.placeSearch = $('.selectsearchroot').val()
      });
      $('.placeSearchStore').on('select2:select', function (e: any) {
        self.nameStore = 'All';
        self.locationStore = 'All';
        self.cityStore = 'All';
        self.placeSearchStore = $('.placeSearchStore').val()
        self.pipeFilter1();
        self.rootA.forEach((element: any) => {
          if(element.id == $('.placeSearchStore').val()){
            self.nameStore = element.name;
            self.locationStore = element.location;
            self.cityStore = element.city;
          } else if($('.placeSearchStore').val() === 'All') {
            self.nameStore = 'All';
          }
        });
      });
      $('.selectpin').on('select2:select', function (e: any) {
        self.selectpin = $('.selectpin').val()
        self.pipeFilter();
      });
      $('.selectpinAdmin').on('select2:select', function (e: any) {
        self.selectpinAdmin = $('.selectpinAdmin').val()
        self.pipeFilterAdmin();
      });
      $('.selectpinAdmin1').on('select2:select', function (e: any) {
        self.selectpinAdmin1 = $('.selectpinAdmin1').val()
      });
      $('.selectpinBar').on('select2:select', function (e: any) {
        self.selectpinBar = $('.selectpinBar').val()
        self.pipeFilter2();
      });
      $('.selectsearchroot000').on('select2:select', function (e: any) {
        self.serchCode = $('.selectsearchroot000').val()
      });
      $('.serchCodeStore').on('select2:select', function (e: any) {
        self.codeStore = 'All';
        self.descriptionStore = 'All'
        self.categoryStore = 'All';
        self.serchCodeStore = $('.serchCodeStore').val()
        self.arre.forEach((element: any) => {
          if(element.code == self.serchCodeStore) {
            self.codeStore = element.code;
            self.descriptionStore = element.description;
            self.categoryStore = element.categoryname;
          }
        });
        self.pipeFilter1();
      });
      $('.selectsearchroot00000').on('select2:select', function (e: any) {
        self.serchCode00 = $('.selectsearchroot00000').val()
        self.pipeFilter2();
      });
    // }, 500);
    $('.fromDA').val(new Date().toJSON().slice(0,10));
    $('.toDA').val(new Date().toJSON().slice(0,10));
    $('.fromDA1').val(new Date().toJSON().slice(0,10));
    $('.toDA1').val(new Date().toJSON().slice(0,10));
    $('.fromDA2').val(new Date().toJSON().slice(0,10));
    $('.toDA2').val(new Date().toJSON().slice(0,10));
    $('.fromDA3').val(new Date().toJSON().slice(0,10));
    $('.toDA3').val(new Date().toJSON().slice(0,10));
    this.datereceipt = new Date().toJSON().slice(0,10);
    this.dateorder = new Date().toJSON().slice(0,10);
    $('.goQN009').on('select2:select', function (e: any) {
      self.yarbs = $('.goQN009').val();})
      $('.goQN').on('select2:select', function (e: any) {
        self.yarbsS = $('.goQN').val();
        if($('.goQN').val() == 'All'){
          self.namePr = 'All';
            self.cityPr = 'All';
            self.adressPr = 'All';
        } else {
        self.arreCustomer.forEach((element: any) => {
          if(element.id == $('.goQN').val()) {
            self.namePr = element.name;
            self.cityPr = element.city;
            self.adressPr = element.adress;

          }
          // else {
          //   self.namePr = 'All';
          //   self.cityPr = 'All';
          //   self.adressPr = 'All';

          // }
        });
      }
      self.pipeAreaSales0();
      })
      $('.select2Q').on('select2:select', function (e: any) {
        self.yarbs000 = $('.select2Q').val();
        if($('.select2Q').val() == 'All'){
          self.nameCustomerSales = 'All';
          self.dateSales = 'All';
          self.adreesCustomerSaled = 'All';
          self.cityCustomerSaled = 'All';
        } else {
          self.arreNo00.forEach((element0: any) => {
            if(element0.id == $('.select2Q').val()) {
              self.dateSales = element0.dateorder;
              self.arreCustomer.forEach((element: any) => {
                if(element.id == element0.customer_id) {
                  self.nameCustomerSales = element.name;
                  self.adreesCustomerSaled = element.adress;
                  self.cityCustomerSaled = element.city;
                }
              });
            }
          });
        }
      })
      $('.select2QAll').on('select2:select', function (e: any) {
        self.yarbs000All = $('.select2QAll').val();
        if($('.select2QAll').val() == 'All'){
          self.nameCustomerSales = 'All';
          self.dateSales = 'All';
          self.adreesCustomerSaled = 'All';
          self.cityCustomerSaled = 'All';
        } else {
          self.areeAllStore.forEach((element0: any) => {
            if(element0.id == $('.select2QAll').val()) {
              self.dateSales = element0.date;
              self.arreCustomer.forEach((element: any) => {
                if(element.id == element0.customer_id) {
                  self.nameCustomerSales = element.name;
                  self.adreesCustomerSaled = element.adress;
                  self.cityCustomerSaled = element.city;
                }
              });
            }
          });
        }
      })
      $('.select2QAll0').on('select2:select', function (e: any) {
        self.yarbs000All0 = $('.select2QAll0').val();
        if($('.select2QAll0').val() == 'All'){
          self.nameCustomerSales = 'All';
          self.dateSales = 'All';
          self.adreesCustomerSaled = 'All';
          self.cityCustomerSaled = 'All';
        } else {
          self.areeAllSales.forEach((element0: any) => {
            if(element0.id == $('.select2QAll0').val()) {
              self.dateSales = element0.date;
              self.arreCustomer.forEach((element: any) => {
                if(element.id == element0.customer_id) {
                  self.nameCustomerSales = element.name;
                  self.adreesCustomerSaled = element.adress;
                  self.cityCustomerSaled = element.city;
                }
              });
            }
          });
        }
      })
      $('.areaSelect').on('select2:select', function (e: any) {
        self.yarbs000All0Sales = $('.areaSelect').val();
        self.pipeAreaSalesAnother();
      })
      $('.searchsupplierCountry').on('select2:select', function (e: any) {
        self.searchsupplierCountry = $('.searchsupplierCountry').val();
      })
      $('.searchsupplierCountry1').on('select2:select', function (e: any) {
        self.searchsupplierCountry1 = $('.searchsupplierCountry1').val();
      })
  }

}
